// extracted by mini-css-extract-plugin
module.exports = {"infomsg":"zkX2K","NewUIInfoMsg":"fd3WY","small":"hRZNM","icon":"k5e8_","right":"OYQVR","center":"Kg3gf"};